import React, { useState } from "react";
import { motion } from "framer-motion";
import "../../../programs.css";
import bgImage from "../../../Image/hr.png";
import HRFAQ from "./HRFAQ";
import HRCurriculum from "./HRCurriculum";
import Certificate from "../../Certificate";
import SkillPage from "../../SkillPage";
import HRPricing from "./HRPricing";
import { Link } from "react-router-dom";
export default function HumanResources() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    college: "",
    program: "Human Resources",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxpGr46MBF4HmNpxOYLbt2mQRcjEVPS5PtI1iZdXAMgIxORthvV4iD0Ev1zPEAsXZoK/exec";

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (data.status === "success" || res.ok) {
        alert("Application submitted successfully!");
        setForm({
          fullName: "",
          email: "",
          phone: "",
          college: "",
          program: "Human Resources",
        });
      } else {
        if (res.ok) {
          alert("Application submitted successfully!");
          setForm({
            fullName: "",
            email: "",
            phone: "",
            college: "",
            program: "Human Resources",
          });
        } else {
          console.error("Submit error:", data);
          alert("There was an error submitting the form. Try again later.");
        }
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Network error — please check your connection and try again.");
    }
  };

  return (
    <>
      <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="program-detail-main">
          <h1 className="program-detail-title">Human Resources</h1>
          <p className="program-detail-desc">
            Human Resource isn’t just hiring—it’s shaping people, guiding teams,
            and building workplace culture. HR understands skills, manages
            emotions, resolves conflicts, and creates growth paths. It connects
            talent to opportunity and ensures organizations run with trust,
            clarity, and respect.
          </p>
          <div className="program-detail-actions">
            <Link to="/register">
              <button className="register-btn">Register Now</button>
            </Link>
            <Link to="/contact-us">
              <button className="expert-btn">Talk To Expert</button>
            </Link>
          </div>
        </div>
      </div>

      {/* -------------------- NEW SECTION START -------------------- */}

      <div className="program-container">
        <motion.div
          className="program-left1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="program-heading1">Program Overview</h2>
          <p className="program-description1">
            Human Resource goes beyond hiring—it shapes how people work, grow,
            and stay motivated. At Acadme, you learn how real companies operate:
            recruitment strategy, onboarding, behavioral psychology, workplace
            conflict, payroll basics, performance reviews, and culture building.
            You’ll explore why employees leave, what keeps them engaged, and how
            HR decisions impact productivity. This isn’t just classroom
            theory—you work with real companies, screen genuine candidates,
            manage communication, and support hiring tasks during internship.
            You gain practical confidence, emotional intelligence, and
            professional communication skills HR leaders rely on. So enroll
            yourself, and with just one click unlock endless learning and
            opportunities that lead to real career growth.
          </p>
        </motion.div>
        <motion.form
          className="program-form"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          onSubmit={handleSubmit}
        >
          <h3 className="form-title">Apply Now</h3>

          <div className="input-group">
            <label>
              <i className="fas fa-user"></i> Full Name
            </label>
            <input
              type="text"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-envelope"></i> Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-phone"></i> Phone Number
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+91 xxxxxxxxxx"
              maxLength="10"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-university"></i> College Name
            </label>
            <input
              type="text"
              name="college"
              value={form.college}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-code"></i> Program
            </label>
            <input type="text" name="program" value={form.program} readOnly />
          </div>

          <button className="submit-btn" type="submit">
            Submit
          </button>
        </motion.form>
      </div>

      {/* -------------------- NEW SECTION END -------------------- */}

      <HRCurriculum />
      <SkillPage />
      <Certificate />
      <HRPricing />
      <HRFAQ />
    </>
  );
}
